// src/components/Footer.js
import React from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaGithub, FaLinkedin, FaTwitter, FaFacebook, FaWhatsapp,
  FaMapMarkerAlt, FaPhone, FaEnvelope,
} from "react-icons/fa";
import { useSite } from "../context/SiteContext";
import "./Footer.css";

// Import logo — try/catch so the app doesn't crash if the file is missing
let logo = null;
try { logo = require("../assets/logo.png"); } catch (_) {}

const ICON_MAP = { FaGithub, FaLinkedin, FaTwitter, FaFacebook, FaWhatsapp };

const NAV_LINKS = [
  { to: "/",               label: "Home"           },
  { to: "/about",          label: "About"          },
  { to: "/projects",       label: "Projects"       },
  { to: "/certifications", label: "Certifications" },
  { to: "/contact",        label: "Contact"        },
];

// "Raphael Tildai" → "RT"
const getInitials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

const Footer = () => {
  const { profile, socials } = useSite();
  const initials = getInitials(profile.displayName || profile.name || "RT");

  return (
    <footer className="footer">
      <div className="container footer__inner">

        {/* ── Brand ── */}
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            <span className={`footer__logo-mark${logo ? " footer__logo-mark--img" : ""}`}>
              {logo
                ? <img src={logo} alt={profile.displayName || "Logo"} className="footer__logo-img" />
                : initials
              }
            </span>
            <span className="footer__logo-text">
              {profile.displayName || "Raphael Tildai"}
            </span>
          </Link>

          <p className="footer__tagline">
            {profile.tagline ||
              "Harnessing the power of technology to create innovative solutions for a better society."}
          </p>

          <div className="footer__socials">
            {socials.map(({ id, label, url, icon }) => {
              const Icon = ICON_MAP[icon];
              return Icon ? (
                <a key={id} href={url} target="_blank" rel="noreferrer"
                   className="footer__social" aria-label={label}>
                  <Icon size={16} />
                </a>
              ) : null;
            })}
          </div>
        </div>

        {/* ── Navigation ── */}
        <div className="footer__col">
          <h4 className="footer__heading">Navigation</h4>
          <ul className="footer__links">
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <NavLink to={to} end={to === "/"} className="footer__link">{label}</NavLink>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Contact ── */}
        <div className="footer__col">
          <h4 className="footer__heading">Contact</h4>
          <ul className="footer__contact-list">
            {profile.location && (
              <li><FaMapMarkerAlt size={13} /><span>{profile.location}</span></li>
            )}
            {profile.phone && (
              <li><FaPhone size={13} /><a href={`tel:${profile.phone}`}>{profile.phone}</a></li>
            )}
            {profile.email && (
              <li><FaEnvelope size={13} /><a href={`mailto:${profile.email}`}>{profile.email}</a></li>
            )}
          </ul>
        </div>

      </div>

      {/* ── Bottom bar ── */}
      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>© {new Date().getFullYear()} {profile.displayName || "Raphael Tildai"}. All rights reserved.</p>
          {profile.website && (
            <p>
              <a href={profile.website} target="_blank" rel="noreferrer">
                {profile.website.replace("https://", "")}
              </a>
            </p>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;